var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNpsreser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 28,
    viewBox: "0 0 39 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.885315 1V18.8757C0.885315 19.428 1.33303 19.8757 1.88532 19.8757H2.59624C3.14852 19.8757 3.59624 19.428 3.59624 18.8757V11.0926H14.5309V18.8757C14.5309 19.428 14.9786 19.8757 15.5309 19.8757H16.2418C16.7941 19.8757 17.2418 19.428 17.2418 18.8757V2.69918V2.34723H28.6925V3.69682V7.91652H31.4091V1.34959C31.4091 0.604231 30.7915 0 30.0295 0H15.7368H15.5309C14.9786 0 14.5309 0.447716 14.5309 1V8.78319H3.59624V1C3.59624 0.447715 3.14852 0 2.59624 0H1.88532C1.33303 0 0.885315 0.447716 0.885315 1Z",
    fill: "url(#paint0_linear_6177_15591)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6925 18.547C28.6925 19.2808 29.3006 19.8757 30.0508 19.8757C30.801 19.8757 31.4091 19.2808 31.4091 18.547V10.8333L28.6925 11.0926V18.547Z",
    fill: "url(#paint1_linear_6177_15591)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6963 25.4065L25.6963 25.4066L25.7062 25.4116C27.2675 26.2082 29.0193 26.6 30.9482 26.6C32.6071 26.6 34.1239 26.3002 35.4885 25.6889L35.4885 25.689L35.4963 25.6854C36.4664 25.2341 37.2995 24.6363 37.9879 23.8897C38.7232 23.0923 38.3925 21.9393 37.5972 21.4368C36.8085 20.9384 35.85 21.1784 35.2634 21.7386C34.8223 22.1599 34.3216 22.4944 33.7583 22.7433C32.8938 23.1253 31.9477 23.3195 30.9127 23.3195C29.675 23.3195 28.5774 23.0636 27.6075 22.5631C26.6369 22.0405 25.878 21.3228 25.3203 20.4047C24.7703 19.4995 24.4846 18.4219 24.4846 17.1498C24.4846 15.8777 24.7703 14.8001 25.3203 13.8948C25.8776 12.9775 26.6351 12.2721 27.6032 11.7717L27.6032 11.7718L27.6118 11.7672C28.5811 11.2461 29.677 10.9801 30.9127 10.9801C31.9477 10.9801 32.8938 11.1742 33.7583 11.5563C34.3198 11.8044 34.8196 12.1425 35.2606 12.5727C35.8455 13.1433 36.8117 13.3922 37.6071 12.8896C38.3963 12.3908 38.7309 11.2481 38.0063 10.4495L37.562 10.8526L38.0063 10.4495C37.313 9.68525 36.471 9.08379 35.4885 8.64367C34.1239 8.03241 32.6071 7.73264 30.9482 7.73264C29.0192 7.73264 27.2675 8.1244 25.7062 8.92097L25.7062 8.92095L25.7027 8.92278C24.1684 9.7184 22.9506 10.8252 22.063 12.2409C21.1681 13.6681 20.729 15.3113 20.729 17.1498C20.729 18.968 21.1689 20.609 22.0606 22.055L22.0606 22.055L22.063 22.0587C22.9496 23.4728 24.1653 24.5892 25.6963 25.4065Z",
    stroke: "url(#paint2_linear_6177_15591)",
    strokeWidth: 1.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6177_15591",
    x1: 20.8664,
    y1: -1.24223,
    x2: 31.4161,
    y2: 18.8194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFCE73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531251,
    stopColor: "#FEF0B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEA86F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6177_15591",
    x1: 20.8664,
    y1: -1.24223,
    x2: 31.4161,
    y2: 18.8194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFCE73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531251,
    stopColor: "#FEF0B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEA86F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6177_15591",
    x1: 32.4123,
    y1: 7.22843,
    x2: 43.6296,
    y2: 20.5396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFCE73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531251,
    stopColor: "#FEF0B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEA86F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNpsreser);
export default __webpack_public_path__ + "static/media/npsreser.22bd7adc06fa287c8008c039f6709e17.svg";
export { ForwardRef as ReactComponent };